<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update Tag</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />



        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Tag:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="tag"
                v-model="tagDescription.tag"
                v-validate="'required'"
                data-vv-as="Tag"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('tag')"
              >{{ errors.first("tag") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                name="description"
                class="w-full"
                v-model="tagDescription.description"
                v-validate="'required'"
                data-vv-as="Tag"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Type:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="name"
                name="type"
                :options="tag_types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="tagDescription.type"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
            <span class="text-danger text-sm mt-2">{{
              please_choose_type
            }}</span>
          </div>

          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="updateForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <DataGrid :context="'Tags'" 
            ref="tags"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleTagManagement from "@/store/tag-management/moduleTagManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
       please_choose_type: null,
      selected_sales_developer: [],
      tag_types: [
        {
          slug: "account",
          name: "Account"
        },
        {
          slug: "contact",
          name: "Contact"
        }
      ],
      user_role: null,
      tagDescription: [],
      tag_id: null,
      columnDefs: [
        {
          headerName: "Tag",
          flex: 1,
          field: "tag",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          flex: 1,
          field: "description",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

          headerName: "Type",
          field: "type",

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      dataSource: {},
      records: [],
      selected: [],
      allTags: [],
      abilities: null,
      tagDescription: {
          tag: null,
        description: null,
        type: null,
        sales_developer_id:null
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleTagManagement,
    DataGrid
      },
  created() {
    var self = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (this.user_role != 'Sales Developer'){
      this.$router.replace("/unauthorized")
    }


    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleTagManagement.isRegistered) {
      this.$store.registerModule("TagsManagement", moduleTagManagement);
      moduleTagManagement.isRegistered = true;
    }
  },
  mounted() {
    this.tag_id = this.$route.params.tagId;
    this.fetchTag();
  },
  watch: {},
  methods: {
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
                    params.request.sales_developer_id = self.user_id;

          self.$store
            .dispatch("TagsManagement/getAllTags", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.tags.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.tags.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateTags();
        }
      });
    },
    updateTags() {
      this.$store
        .dispatch("TagsManagement/updateTags", this.tagDescription)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Tags Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Tags Updated",
              text: "The tags was updated successfully"
            });
            this.$router.push({ path: "/tags" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchTag() {
      let self = this;
      this.$store
        .dispatch("TagsManagement/fetchTags", self.tag_id)
        .then(res => {
          let result = JSON.parse(res.data);

          self.tagDescription = result[0];
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
